"use strict";
/**
 * @file Created on Mon Jan 07 2019
 * @author Tomáš Leity
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checks whether the given date is older than another date or not.
 */


var DateOlderThanValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(DateOlderThanValidator, _Validator_1$Validato);

  function DateOlderThanValidator(dependentMoment) {
    var _this;

    var compareEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var compareDayOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var dateFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DD/MM/YYYY';
    var errorMessage = arguments.length > 4 ? arguments[4] : undefined;
    var optional = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, DateOlderThanValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateOlderThanValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.dependentMoment = dependentMoment;
    _this.compareEqual = compareEqual;
    _this.compareDayOnly = compareDayOnly;
    _this.dateFormat = dateFormat;
    _this.errorMessage = errorMessage;
    _this.optional = optional;
    return _this;
  }

  _createClass(DateOlderThanValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (!value && this.optional || !moment.isMoment(this.dependentMoment)) {
        return new ValidationResult_1.ValidationSuccess(value);
      }

      if (!moment.isMoment(value)) {
        return new ValidationResult_1.ValidationError(DateOlderThanValidator.DATE_INVALID_FORMAT);
      }

      var result;

      if (!this.compareDayOnly) {
        result = this.compareEqual && value.isSameOrAfter(this.dependentMoment) || value.isAfter(this.dependentMoment);
      } else {
        result = this.compareEqual && value.isSameOrAfter(this.dependentMoment, 'day') || value.isAfter(this.dependentMoment, 'day');
      }

      if (!result) {
        var errorMessage = this.errorMessage || DateOlderThanValidator.DATE_YOUNGER_THAN_ERROR;
        return new ValidationResult_1.ValidationError(errorMessage, this.dependentMoment.format(this.dateFormat));
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return DateOlderThanValidator;
}(Validator_1.Validator);

exports.DateOlderThanValidator = DateOlderThanValidator;
DateOlderThanValidator.DATE_INVALID_FORMAT = 'BAD_DATE_INVALID_FORMAT';
DateOlderThanValidator.DATE_YOUNGER_THAN_ERROR = 'DATE_YOUNGER_THAN';